// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Button_buttonContainer__0MWME","outlined":"Button_outlined__-tAZi","CopyButton":"Button_CopyButton__98Brt"};